// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"82b72373","455":"bfd9a0a5","977":"0d8e9ce9"}[chunkId] + ".chunk.js";
};